import { render, staticRenderFns } from "./quick.vue?vue&type=template&id=0326c642&scoped=true"
import script from "./quick.vue?vue&type=script&lang=js"
export * from "./quick.vue?vue&type=script&lang=js"
import style0 from "./quick.vue?vue&type=style&index=0&id=0326c642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0326c642",
  null
  
)

export default component.exports